import { render, staticRenderFns } from "./UsersBulkActionsMenu.vue?vue&type=template&id=ab3a3480&scoped=true"
import script from "./UsersBulkActionsMenu.vue?vue&type=script&lang=js"
export * from "./UsersBulkActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./UsersBulkActionsMenu.vue?vue&type=style&index=0&id=ab3a3480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3a3480",
  null
  
)

export default component.exports